import React from 'react';
import { Card, CardContent, CardHeader } from './ui/card';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    ReferenceLine
} from 'recharts';

interface OpenRateGapChartProps {
    data: {
        name: string;
        actual: number;
        estimated: number;
        gap: number;
    }[];
}

const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
        return (
            <div className="bg-white p-4 border rounded shadow-md">
                <p className="font-bold mb-2">{label}</p>
                <p className="text-sm text-blue-600">
                    Actual Open Rate: {payload[0].value}%
                </p>
                <p className="text-sm text-green-600">
                    Potential Uplift: {payload[1].value}%
                </p>
                <div className="mt-2 pt-2 border-t">
                    <p className="text-sm font-bold text-gray-800">
                        Total Potential: {(payload[0].value + payload[1].value).toFixed(2)}%
                    </p>
                </div>
            </div>
        );
    }
    return null;
};

export default function OpenRateGapChart({ data }: OpenRateGapChartProps) {
    return (
        <Card className="col-span-1 shadow-md border-gray-300">
            <CardHeader className="bg-gradient-to-r from-gray-50 to-blue-50">
                <h3 className="text-lg font-bold">
                    Open Rate Potential Analysis
                </h3>
                <p className="text-xs text-gray-500">
                    Gap between actual opens and estimated total opens
                </p>
            </CardHeader>
            <CardContent className="p-6">
                <div className="h-[300px] w-full">
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                            data={data}
                            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                        >
                            <CartesianGrid strokeDasharray="3 3" vertical={false} />
                            <XAxis dataKey="name" />
                            <YAxis
                                unit="%"
                                domain={[0, 'auto']}
                            />
                            <Tooltip content={<CustomTooltip />} />
                            <Legend />
                            {/* Actual Open Rate (Bottom Stack) */}
                            <Bar
                                dataKey="actual"
                                stackId="a"
                                name="Actual Open Rate"
                                fill="#2563eb"
                                radius={[0, 0, 4, 4]}
                            />
                            {/* Gap (Top Stack) */}
                            <Bar
                                dataKey="gap"
                                stackId="a"
                                name="Potential Gap"
                                fill="#82ca9d"
                                opacity={0.6}
                                radius={[4, 4, 0, 0]}
                            />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </CardContent>
        </Card>
    );
}
